import { render, staticRenderFns } from "./AiChatTextArea.vue?vue&type=template&id=1142087c&"
import script from "./AiChatTextArea.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiChatTextArea.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports